import { createSlice } from "@reduxjs/toolkit";

const initialBankState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  currentOrganizationFeatures: [],
  lastError: null,
  defaultFeature: []
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const organizationFeatureSlice = createSlice({
  name: "organizationFeature",
  initialState: initialBankState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    //  find default feature
    fetchedOrgDefaultFeature: (state, action) => {
      state.defaultFeature = action.payload.defaultFeature;
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
    },

    // find all
    fetchedCurrentOrgFeatures: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.currentOrganizationFeatures = action.payload.list;
    },

    // find
    organizationFeaturesFetched: (state, action) => {
      const { total_items, items } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = items;
      state.totalCount = total_items;
    },
    // Set to default state actionLoading & error
    organizationFeatureReload: (state, action) => {
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
    }
  }
});
